/*
 * @Author: Liux
 * @Date: 2019-12-02 08:47:52
 * @LastEditor: Liux
 * @LastEditTime: 2019-12-02 09:43:01
 */
import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class AdCalendarDateFormatter extends CalendarDateFormatter {
  public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'EEEEEE', locale);
  }
}
